import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const AuthorInfoBox = styled.div`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 20px 15px;
`;

export const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr 60px;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
`;

export const MainInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const WorkingHours = styled(Typography.Caption)``;

export const Link = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Warning = styled.div`
  margin-top: 10px;
  padding: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.redLight};
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 5px;
  border: ${({ theme }) => `1px solid ${theme.palette.system.red}`};
`;

export const WarningTitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.red};
  margin-bottom: 5px;
`;

export const AddShopFavorite = styled.button<{ $isFavoritedLocal: boolean }>`
  padding: 17px 39px;
  border-radius: 14px;
  color: ${({ theme }) => theme.palette.system.blue};
  background: ${({ theme }) => theme.palette.system.lightBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 0;
  margin-bottom: 10px;

  ${({ $isFavoritedLocal }) =>
    $isFavoritedLocal &&
    css`
      color: ${({ theme }) => theme.palette.primary.labels};
      background: ${({ theme }) => theme.palette.secondary.background};
    `}
`;

export const AuthorName = styled(Typography.Body)`
  font-size: 16px;
`;

export const Avatar = styled.img`
  border-radius: 14px;
`;
